
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.833 25H1.167A1.17 1.17 0 010 23.833V5.167A1.17 1.17 0 011.167 4h25.666A1.17 1.17 0 0128 5.167v18.666A1.17 1.17 0 0126.833 25zm-24.5-2.333h23.334V6.333H2.333v16.334z","fill":"#262626"}}),_c('path',{attrs:{"d":"M22.167 11h-2.334a1.17 1.17 0 01-1.166-1.167 1.17 1.17 0 011.166-1.166h2.334a1.17 1.17 0 011.166 1.166A1.17 1.17 0 0122.167 11zM22.167 15.667h-2.334a1.17 1.17 0 01-1.166-1.167 1.17 1.17 0 011.166-1.167h2.334a1.17 1.17 0 011.166 1.167 1.17 1.17 0 01-1.166 1.167zM22.167 20.333h-2.334a1.17 1.17 0 01-1.166-1.166A1.17 1.17 0 0119.833 18h2.334a1.17 1.17 0 011.166 1.167 1.17 1.17 0 01-1.166 1.166zM9.567 13.322c.303.128.618.186.933.186.163 0 .315-.011.478-.046a2.512 2.512 0 001.249-.665 2.45 2.45 0 00.525-2.66 2.502 2.502 0 00-.899-1.097c-.933-.63-2.286-.49-3.08.303a2.436 2.436 0 00-.711 1.727 2.427 2.427 0 001.505 2.252zM10.5 14.488c-3.22 0-5.845 2.404-5.845 5.355 0 .269.222.49.49.49h10.722c.268 0 .49-.221.49-.49 0-2.951-2.625-5.355-5.845-5.355H10.5z","fill":"#262626"}})])
          )
        }
      }
    